"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGeolocationStencil = exports.geolocationStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.geolocationStencilDefinition = {
    view: {
        label: 'Geolocation',
        category: 'location',
        group: 'Misc.',
        titleItems: ['title'],
        imageItems: ['geodata'],
        contentAreas: [
            {
                name: 'main',
                items: ['title', 'geodata'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'venue',
                            'location',
                            'url',
                            'city',
                            'state',
                            'country-code',
                            'country-name',
                            'continent',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
        ],
    },
    content: {
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.geoDataPropertyDefinition.name]: properties_1.geoDataPropertyDefinition,
        [properties_1.venuePropertyDefinition.name]: properties_1.venuePropertyDefinition,
        [properties_1.locationPropertyDefinition.name]: properties_1.locationPropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
        [properties_1.cityPropertyDefinition.name]: properties_1.cityPropertyDefinition,
        [properties_1.statePropertyDefinition.name]: properties_1.statePropertyDefinition,
        [properties_1.countryCodePropertyDefinition.name]: properties_1.countryCodePropertyDefinition,
        [properties_1.countryNamePropertyDefinition.name]: properties_1.countryNamePropertyDefinition,
        [properties_1.continentPropertyDefinition.name]: properties_1.continentPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
    },
    roles: [],
    localizations: [],
    spaces: [
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'illume',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-advancedtechnologies',
        'redbull-racing',
        'redbull-powertrains',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
        'xalps',
    ],
    name: 'geolocation',
};
const isGeolocationStencil = (stencil) => {
    return stencil.name === exports.geolocationStencilDefinition.name;
};
exports.isGeolocationStencil = isGeolocationStencil;
//# sourceMappingURL=data:application/json;base64,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